<!-- @format -->

<template>
	<div class="u-comment">
		<div class="comment-form">
			<div class="header">
				<span class="header-title">评论</span>
			</div>
			<div class="content">
				<div class="avatar-box">
					<el-avatar :size="40">
						<el-icon :size="25"> <UserFilled /> </el-icon>
					</el-avatar>
				</div>
				<InputBox placeholder="请输入评论" content-btn="发布评论" :disabled-input="disabledComment" />
			</div>
		</div>
		<div v-if="total > 0" class="comment-list-wrapper">
			<slot>
				<div class="title">全部评论</div>
			</slot>
			<CommentList
				:data="comments"
				:total="total"
				:show-size="isNull(showSize, 5)"
				:disabled-reply="disabledReply"
			></CommentList>
		</div>
	</div>
</template>

<script setup lang="ts">
	import InputBox from './components/input-box.vue';
	import CommentList from './components/comment-list.vue';
	import { isNull } from './utils';

	interface Props {
		config: any;
		page?: boolean;
		isFrontPage?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		page: false,
		isFrontPage: true,
		disabledComment: false,
		disabledReply: false,
	});

	const { comments, showSize, replyShowSize, total, disabledComment, disabledReply } = toRefs(props.config);

	const emit = defineEmits<{
		(e: 'submit', { content, parentId, reply, finish }: any): void;
		(e: 'replyPage', { parentId, pageNum, pageSize, finish }: any): void;
	}>();

	/**
	 * 提交评论
	 */
	const submit = ({ content, parentId, reply, clear }: any) => {
		// 添加评论
		const finish = (comment) => {
			// 清空输入框内容
			clear();
			// 提交评论添加到评论列表
			if (parentId) {
				const rawComment = comments.value.find((v) => v.id == parentId);
				if (rawComment) {
					const replys = rawComment.reply;
					if (replys) {
						replys.list.push(comment);
						replys.total++;
					} else {
						rawComment.reply = {
							total: 1,
							list: [comment],
						};
					}
				}
			} else {
				comments.value.push(comment);
			}
		};
		emit('submit', { content, parentId, reply, finish });
	};

	provide('submit', submit);

	// 回复盒子
	const replyBoxParam = {
		page: props.page,
		replyPage: (parentId, pageNum, pageSize, finish) => {
			emit('replyPage', { parentId, pageNum, pageSize, finish });
		},
		replyShowSize: isNull(replyShowSize, 3),
		comments,
		isFrontPage: props.isFrontPage,
	};
	provide('InjectReplyBox', replyBoxParam);

	/**
	 * 删除当前评论
	 * @param comment
	 */
	const remove = (comment) => {
		// 删除评论数据操作
		const { parentId, id } = comment;
		if (parentId) {
			const comment = comments.value.find((item) => item.id == parentId);
			const reply = comment?.reply;
			if (reply) {
				const index = reply.list.findIndex((item) => item.id == id);
				if (index != -1) {
					reply.list.splice(index, 1);
					reply.total--;
				}
			}
		} else {
			const index = comments.value.findIndex((item) => item.id == id);
			if (index != -1) {
				comments.value.splice(index, 1);
			}
		}
	};

	const usePage = (pageNum: number, pageSize: number, arr: any[]) => {
		const skipNum = (pageNum - 1) * pageSize;
		const newArr =
			skipNum + pageSize >= arr.length ? arr.slice(skipNum, arr.length) : arr.slice(skipNum, skipNum + pageSize);
		return newArr;
	};

	defineExpose({
		remove,
		usePage,
	});
</script>

<style lang="scss" scoped>
	.u-comment {
		background-color: #fff;
		color: #303133;
		border-radius: 4px;
		// 设置的边框和内边距的值是包含在width内
		box-sizing: border-box;

		.comment-form {
			.header {
				.header-title {
					font-size: 15px;
					//多行元素的空间量，如多行文本的间距。
					line-height: 30px;
					font-weight: 600;
				}
			}

			.content {
				margin-top: 5px;
				display: flex;

				.el-avatar {
					margin-right: 16px;
				}
			}
		}

		.comment-list-wrapper {
			//padding: 40px 0 16px;

			.title {
				display: flex;
				align-items: center;
				position: relative;
				line-height: 30px;
				font-weight: 600;
				font-size: 15px;
				width: 100%;
				justify-content: space-between;
			}
		}
	}
</style>
